import React, { useState, useRef, useEffect } from "react";
import moment from "moment";

const StickyCallNote = ({ callData }) => {
    const [visible, setVisible] = useState(true);
    const [position, setPosition] = useState({ x: 1000, y: 100 });
    const [dragging, setDragging] = useState(false);
    const offset = useRef({ x: 0, y: 0 });

    const noteRef = useRef(null);

    const inactiveEmployee = callData.filter(
        (item) => item.last_call_time && moment().diff(moment(item.last_call_time), "minutes") > 10
    );

    // Mouse handlers for drag
    const handleMouseDown = (e) => {
        setDragging(true);
        const rect = noteRef.current.getBoundingClientRect();
        offset.current = {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        };
    };

    const handleMouseMove = (e) => {
        if (!dragging) return;
        const newX = e.clientX - offset.current.x;
        const newY = e.clientY - offset.current.y;
        setPosition({ x: newX, y: newY });
    };

    const handleMouseUp = () => setDragging(false);

    useEffect(() => {
        if (dragging) {
            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);
        } else {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        }
        return () => {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };
    }, [dragging]);

    return (
        <>
            {visible ? (
                <div
                    ref={noteRef}
                    onMouseDown={handleMouseDown}
                    style={{
                        position: "fixed",
                        top: position.y,
                        left: position.x,
                        background: "#fffbe6",
                        border: "1px solid #ffe58f",
                        padding: "12px",
                        borderRadius: "8px",
                        boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                        width: "250px",
                        maxHeight: "400px",
                        overflowY: "auto",
                        cursor: "move",
                        zIndex: 9999,
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <h6 style={{ color: "#d48806", marginBottom: "8px" }}>🔴 No Call in 10+ mins</h6>
                        <button
                            onClick={() => setVisible(false)}
                            style={{
                                background: "transparent",
                                border: "none",
                                fontWeight: "bold",
                                fontSize: "16px",
                                cursor: "pointer",
                                color: "#d48806",
                            }}
                        >
                            ✕
                        </button>
                    </div>
                    {inactiveEmployee.length === 0 ? (
                        <p style={{ fontSize: "14px" }}>All recent callers ✅</p>
                    ) : (
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {inactiveEmployee.map((item, index) => (
                                <div
                                    key={index}
                                    style={{
                                        padding: "10px",
                                        border: "1px solid #ffe58f",
                                        borderRadius: "6px",
                                        backgroundColor: "#fffdf3",
                                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                                        fontSize: "14px",
                                    }}
                                >
                                    <div style={{ fontWeight: "600", color: "#333" }}>
                                        👤 {item.name || "Unknown"}
                                    </div>
                                    <div style={{ color: "#777", marginTop: "4px" }}>
                                        📞 Last Call: <span style={{ fontWeight: 500 }}>{moment(item.last_call_time).fromNow()}</span>
                                    </div>
                                </div>
                            ))}
                        </div>

                    )}
                </div>
            ) : (
                <button
                    onClick={() => setVisible(true)}
                    style={{
                        position: "fixed",
                        top: position.y,
                        left: position.x,
                        zIndex: 9999,
                        background: "#ffe58f",
                        border: "1px solid #d48806",
                        borderRadius: "8px",
                        padding: "6px 12px",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "bold",
                    }}
                >
                    📌 View Inactive Callers
                </button>
            )}
        </>
    );
};

export default StickyCallNote;
